import { useRequest } from '../../requests'
import { appConfigContext } from 'nexchange-service/appServiceConfig'
import { TRequestGetGeoLocation } from '../geoLocation'


const useGeoLocationData = (requestGeoLocationNextApi: TRequestGetGeoLocation) => {
    const {
        data: locationData,
        isLoading,
        error
    } = useRequest(requestGeoLocationNextApi, {
        initialData: null
    })

    // Use the API response's isLocked field which considers the full LOCKED_COUNTRIES list
    // Also consider VPN detection for high-confidence cases
    // Only evaluate if we have valid location data with countryCode, otherwise return false
    const hasValidLocationData = locationData && locationData.countryCode && !isLoading
    const isCountryInRestrictedList = hasValidLocationData ? (
        Boolean(locationData.isLocked) ||
        (locationData.vpnDetection?.isVpnSuspected && locationData.vpnDetection?.confidence === 'high')
    ) : false

    return {
        isCountryInRestrictedList,
        locationData
    }
}

export { useGeoLocationData }